var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
  _vm.showBackComponent
    ? 'isSpecialChannelEnvironment'
    : 'isNotSpecialChannelEnvironment',
  _vm.isFullScreen
    ? 'isFullScreen'
    : _vm.iosFillScreen
      ? 'iosFillScreen'
      : 'nonFullScreen',
],attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view',{staticClass:"router-view-container"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }